import { defaultRenderingStrategy } from './defaultRenderingStrategy';
import SmartPillsRenderingStrategy from './SmartPillsRenderingStrategy';

/**
 * Supplies a strategy and this strategy may come from different sources.
 */
export default function getSmartPillsRenderingStrategy(): SmartPillsRenderingStrategy {
    return defaultRenderingStrategy;
}
